import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { userOption, userResult, RouteCodeModel } from '../../models/orders/order-list-model';
import { Dropdown, DropdownChangeEvent, DropdownFilterEvent } from 'primereact/dropdown';
import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import orderServices from '../../services/orders/orderservice';
import '../../assests/css/common/responsive-ui.css';
import routeCodeServices from '../../services/route-codes/routecode.service';

interface SearchPanelProps {
  onSearch: (filter: {
    keyword?: string | null;
    userID?: number| null;
    routeCodeID?: number[];
  }) => void;
  setLoading: (loading: boolean) => void;
}
 
interface UserOption {
  userID: number;
  name: string;
  primaryContactNbr: string;
}
 
interface UserResult {
  userID: number;
  detail: string;
}
 
const RouteCodeSearch: React.FC<SearchPanelProps> = ({ onSearch, setLoading  }) => {
  
  const { t } = useTranslation();
  const [selectedUser, setSelectedUser] = useState<any>();
  const blankUserDetail: userOption[] = [{ userID: 0, name: '', primaryContactNbr: ''},];
  const [orderUsers, setOrderUsers] = useState<UserOption[]>([{ userID: 0, name: '', primaryContactNbr: '' }]);
  const [orderUserOptions, setOrderUserOptions] = useState<UserResult[]>([]);
  const [selectedRouteCodes, setSelectedRouteCodes] = useState<number[]>([]);
  const [orderUser, setOrderUser] = useState<userResult[]>([]);
  const [keyword, setKeyword] = useState<string>('');
  const [routeCodeOptions, setRouteCodeOptions] = useState<any[]>([]);


  useEffect(() => {
    const loadRouteCodes = async () => {
      try {
        const codes = await routeCodeServices.getRouteCodes();
        setRouteCodeOptions(codes);
      } catch (error) {
        console.error("Error loading route codes:", error);
      }
    };
    setOrderUserOptions(orderUsers.map(user => ({
      userID: user.userID,
      detail: `${user.name}, ${user.primaryContactNbr}`,
    })));
 
    loadRouteCodes();
  }, []);

  const handleDropdownChange = (e: DropdownChangeEvent) => {
    setSelectedUser(e.value);
  }

  const handleDropdownFilter = async (e: DropdownFilterEvent) => {
    if (e.filter.length > 2) {
      try {
        const users = await orderServices.getOrderUsers(e.filter);
        if (users.length > 0) {
          setOrderUsers(users);
          setOrderUserOptions(users.map((user: { userID: any; name: any; primaryContactNbr: any; }) => ({
            userID: user.userID,
            detail: `${user.name}, ${user.primaryContactNbr}`,
          })));
        }
      } catch (error) {
        console.error("Error filtering users:", error);
      }
    }
  };

  const handleRouteCodeChange = (e: MultiSelectChangeEvent) => {
    setSelectedRouteCodes(e.value);
  };

  const handleSearch = () => {
    setLoading(true);
    const searchKeyword = keyword.trim() === '' ? undefined : keyword.trim();
    onSearch({
      keyword: searchKeyword,
      userID: selectedUser || undefined,
      routeCodeID: selectedRouteCodes.length > 0 ? selectedRouteCodes : undefined
    });
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setKeyword(value);
    onSearch({ keyword: value });
  };

  const resetSearchFields = () => {
    setSelectedUser(null);
    setOrderUsers([]); 
    setSelectedRouteCodes([]);
    setKeyword('');
    onSearch({
      keyword: null,
      userID:  null,
      routeCodeID: []
    });
  };

return (
    <div className="col-12">
      <div className="card border-noround p-2" style={{ minHeight: '3.5rem'}}>
        <div className="input-container font-bold text-white border-round" style={{ float: "left", width: "18%" }}>
          <div className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              value={keyword}
             onChange={handleSearchChange}
              // onChange={(e) => setKeyword(e.target.value)}
              placeholder="Keyword Search"
              style={{ width: '100%' }}
            />
             </div>
        </div>
        <div className="dropdown-search font-bold text-white border-round " style={{ float: "left", width: "20%" }}>
          <Dropdown
            id="SearchUser"
            name="SearchUser"
            options={orderUserOptions}
            optionLabel="detail"
            optionValue="userID"
            value={selectedUser}
            onChange={handleDropdownChange}
            onFilter={handleDropdownFilter} filter
            placeholder="Search for User/Mobile" style={{ width: "100%" }}
          />
        </div>
        <div className="dropdown-search font-bold text-white border-round " style={{ float: "left", width: "20%" }}>
          <MultiSelect
            id="RouteCode"
            name="RouteCode"
            options={routeCodeOptions}
            optionLabel="name"
            optionValue="routeCodeID"
            value={selectedRouteCodes}
            display="chip"
            onChange={handleRouteCodeChange}
            placeholder="Choose Route Code" style={{ width: "100%" }}
          />
        </div>

        <div className='button-container ml-5'>
          <div className="filter-button font-bold text-white border-round ml-8" style={{ float: "left", textAlign:'right', width: "10%" }}>
            <Button className=" text-black border-round" 
            style={{ width: "100%", textAlign:'center' }} 
            onClick={handleSearch} severity="success">Filter</Button>
          </div>
          <div className="filter-button font-bold text-white border-round ml-2" 
          style={{ float: "left", textAlign:'right', width: "10%" }}>
            <Button className="text-black border-round" 
            style={{ width: "100%", textAlign:'center' }} 
            onClick={resetSearchFields} severity="secondary" text raised>Reset</Button>
          </div>
      </div>
  </div>
</div>
);
};

export default RouteCodeSearch;